import React, { useState, useEffect, useRef } from "react";
import { Printer, Upload } from "lucide-react";
import { useLanguage } from '../../StoreContext/LanguageContext';
import apiService from "../../config";
import { useSignature } from '../../DigitalSignature/UseSignatue';
import SignaturePad from '../../DigitalSignature/SignaturePad';

const AkshepNirakaranPrasidhiAheval = ({ fetchButtonStatus }) => {

  const printRef = useRef(null);
  //Send to Project Incharge
  const [showSendToProjectInchargeModal, setShowSendToProjectInchargeModal] = useState(false);
  const [usersProjectIncharge, setUsersProjectIncharge] = useState([]);
  const [loadingUsersProjectIncharge, setLoadingUsersProjectIncharge] = useState(false);
  const [selectedUserProjectIncharge, setSelectedUserProjectIncharge] = useState('');
  const [remarksProjectIncharge, setRemarksProjectIncharge] = useState('');
  const [selectedDocumentProjectIncharge, setSelectedDocumentProjectIncharge] = useState(null);
  const [sendingToProjectIncharge, setSendingToProjectIncharge] = useState(false);
  //Send to Tehsildar
  const [showSendToTehsildarModal, setShowSendToTehsildarModal] = useState(false);
  const [usersTehsildar, setUsersTehsildar] = useState([]);
  const [loadingUsersTehsildar, setLoadingUsersTehsildar] = useState(false);
  const [selectedUserTehsildar, setSelectedUserTehsildar] = useState('');
  const [remarksTehsildar, setRemarksTehsildar] = useState('');
  const [selectedDocumentTehsildar, setSelectedDocumentTehsildar] = useState(null);
  const [sendingToTehsildar, setSendingToTehsildar] = useState(false);
  const [projectId, setProjectId] = useState(null);
  const [proposalId, setProposalId] = useState(null);
  const { language, translations } = useLanguage();

  const [fullName, setFullName] = useState('');
  const [designation, setDesignation] = useState('');
  const [showSignaturePad, setShowSignaturePad] = useState(false);
  const [pdfForSigning, setPdfForSigning] = useState(null);
  const [isViewerOpen, setIsViewerOpen] = useState(false);
  const [viewerFile, setViewerFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const {
    uploadStatus,
    uploadError,
    selectedSignDocument,
    resetSignatureState,
    setUploadStatus,
    setUploadError,
    signDocument
  } = useSignature();

  // Digital signature

  const [loadingEdit, setLoadingEdit] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const DEFAULT_MAIN_CONTENT = `जिगाव प्रकल्पामुळे बाधित होत असलेले मौजे कोठरा तालुका शेगाव जिल्हा बुलढाणा येथील प्रकल्पग्रस्तांचे पुनर्वसनांतर्गत भूखंड वाटपाचे अनुषंगाने नवीन गावठाण कोठरा तालुका शेगाव जि. बुलढाणा करीता भूखंड वाटपाची प्रारूप यादी संदर्भीय पत्राद्वारे प्रसिद्ध करण्यात आली असता प्रकल्पग्रस्तांनी आक्षेप अर्ज या कार्यालयास सादर केले आहेत.
प्रकल्पग्रस्तांचे प्राप्त आक्षेप अर्जाचे (एकूण प्राप्त आक्षेप अर्ज ३४) निराकरण करण्यात आले असून त्यासंबंधी निराकरण अहवाल संलग्न करण्यात आला आहे. सदर आक्षेप निराकरण अहवाल प्रसिद्ध करून प्रसिद्धी अहवाल या कार्यालयास सादर करावा. आक्षेप निराकरणाबाबत सचिव, ग्रामपंचायत कार्यालय कोठरा यांनी संबंधित आक्षेपकर्त्यांना अवगत करण्याची दक्षता घ्यावी.';
 
संलग्न: संपादन क्षेत्राची यादी`;

  const [editForm, setEditForm] = useState({
    case_no: "",
    date: "",
    order_no: "",
    objection_place: "",
    objection_date: "",
    main_content: DEFAULT_MAIN_CONTENT
  });

  const [formData, setFormData] = useState({
    notification_no: "",     // जावक क्र.
    date: "",
    subject: "",             // विषय
    reference: "",           // संदर्भ
    default_content: "",     // Main Content
    copy_forwarded_to: "",   // प्रतिलिपी
    // attachment: "",          // संलग्न
    email: ""                // e-mail
  });



  //Get From Localstorage
  const locationData = JSON.parse(localStorage.getItem("locationData") || "{}");

  const district = locationData?.district_name || "";
  const taluka = locationData?.taluka_name || "";
  const village = locationData?.village_name || "";

  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem('userData') || '{}');
    setFullName(userData.full_name || '');
    setDesignation(userData.designation || '');
  }, []);

  // Project Id
  useEffect(() => {
    const getProjectInfo = () => {
      const selectedProject = localStorage.getItem('selectedProject');
      if (selectedProject) {
        try {
          const project = JSON.parse(selectedProject);
          return {
            id: project.project_id || project.id,
            name: project.project_name || project.name
          };
        } catch (e) {
          console.error('Error parsing selected project (selectedProject):', e);
        }
      }

      const userData = localStorage.getItem('userData');
      if (userData) {
        try {
          const user = JSON.parse(userData);
          const projectId = user.data?.project_id || user.project_id;
          const projectName = user.data?.project_name || user.project_name || 'Unknown Project';
          return {
            id: projectId,
            name: projectName
          };
        } catch (e) {
          console.error('Error parsing user data (userData):', e);
        }
      }
      return { id: null, name: null };
    };

    const projectInfo = getProjectInfo();
    setProjectId(projectInfo.id);
    console.log('Current Project Info:', projectInfo);
  }, []);

  // Proposal id
  useEffect(() => {
    const getProposalInfo = () => {
      const currentProposal = JSON.parse(localStorage.getItem('userData') || '{}');

      if (currentProposal) {
        try {
          return {
            proposalId: currentProposal?.data?.default_proposal ||
              currentProposal?.data?.proposal_id ||
              currentProposal?.default_proposal ||
              currentProposal?.proposal_id ||
              null
          }
        } catch (e) {
          console.error('Error parsing current project data (getProposalInfo):', e);
        }
      }
      return { proposalId: null };
    };

    const proposalInfo = getProposalInfo();
    setProposalId(proposalInfo.proposalId);
    console.log('Current Project-Proposal Info:', proposalInfo);
  }, []);

  const USER_ROLES = {
    DATA_ENTRY: 14,
    DRO: 22,
    PROJECT_INCHARGE: 18,
    TEHSILDAR: 5
  };

  // Add this state declaration with your other useState calls:
  const [userRole, setUserRole] = useState(() => {
    try {
      const userData = localStorage.getItem("userData");
      if (userData) {
        const user = JSON.parse(userData);
        return user.user_role || null;
      }
    } catch (error) {
      console.error("Error parsing user data:", error);
    }
    return null;
  });

  const fetchUsersProjectIncharge = async () => {
    const role = 18;
    setLoadingUsersProjectIncharge(true);
    try {
      const response = await apiService.getAllUserRoleProjectIncharge(
        role,
        projectId,
        proposalId
      );

      if (response.status === 200 && response.data) {
        setUsersProjectIncharge(Array.isArray(response.data) ? response.data : []);
      } else {
        setUsersProjectIncharge([]);
      }
    } catch (error) {
      console.error('Error fetching Project Incharge users:', error);
      setUsersProjectIncharge([]);
    } finally {
      setLoadingUsersProjectIncharge(false);
    }
  };

  const fetchUsersTehsildar = async () => {
    const role = 5;
    setLoadingUsersTehsildar(true);
    try {
      const response = await apiService.getAllUserTehsildar(
        role,
        projectId,
        proposalId
      );

      if (response.status === 200 && response.data) {
        setUsersTehsildar(Array.isArray(response.data) ? response.data : []);
      } else {
        setUsersTehsildar([]);
      }
    } catch (error) {
      console.error(error);
      setUsersTehsildar([]);
    } finally {
      setLoadingUsersTehsildar(false);
    }
  };

  const handleUploadedFile = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    resetSignatureState();     // 🔥 important
    setPdfForSigning(file);
    setShowSignaturePad(true);
  };

  useEffect(() => {
    if (!selectedSignDocument) return;

    const postSignedPdf = async () => {
      try {
        const selectedProject = JSON.parse(localStorage.getItem("selectedProject") || "{}");
        const projectId = selectedProject?.id || selectedProject?.project_id;
        const proposalId = localStorage.getItem("currentProposalId");

        if (!projectId || !proposalId) {
          console.error("Missing projectId or proposalId");
          return;
        }

        await apiService.postAddSignaturePDF(
          projectId,
          proposalId,
          "AkshepReport",      // 🔁 change per section
          selectedSignDocument   // ✅ signed PDF only
        );

        const sectionRes = await apiService.getSectionFile(
          projectId,
          proposalId,
          "AkshepReport"
        );

        if (sectionRes?.isSignAvailable && sectionRes.data?.[0]?.file_path) {
          setPreviewUrl(sectionRes.data[0].file_path);
        }

      } catch (error) {
        console.error("Error posting signed PDF:", error);
      }
    };

    postSignedPdf();
  }, [selectedSignDocument]);

  const handleViewSignedPdf = async () => {
    try {
      const selectedProject = JSON.parse(localStorage.getItem("selectedProject") || "{}");
      const projectId = selectedProject?.id || selectedProject?.project_id;
      const proposalId = localStorage.getItem("currentProposalId");

      if (!projectId || !proposalId) {
        alert("Project or Proposal not found");
        return;
      }

      const res = await apiService.getSectionFile(
        projectId,
        proposalId,
        "AkshepReport" // 🔁 change per section
      );

      if (res?.isSignAvailable && res?.data?.[0]?.file_path) {
        setViewerFile(res.data[0].file_path);
        setIsViewerOpen(true);     // modal
        // OR 👉 window.open(res.data[0].file_path, "_blank");
      } else {
        alert("Signed document not available");
      }
    } catch (error) {
      console.error("Error viewing signed PDF:", error);
      alert("Unable to open signed document");
    }
  };

  const SignatureLoader = ({ text }) => (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
      <div className="bg-white rounded-lg p-6 flex flex-col items-center space-y-4">
        <div className="animate-spin rounded-full h-10 w-10 border-4 border-blue-600 border-t-transparent"></div>
        <p className="text-sm font-medium text-gray-700">{text}</p>
      </div>
    </div>
  );

  useEffect(() => {
    if (showSendToProjectInchargeModal) {
      fetchUsersProjectIncharge();
    }
  }, [showSendToProjectInchargeModal]);

  useEffect(() => {
    if (showSendToTehsildarModal) {
      fetchUsersTehsildar();
    }
  }, [showSendToTehsildarModal]);

  useEffect(() => {
    if (projectId && proposalId) {
      fetchEditData();
    }
  }, [projectId, proposalId]);

  const handleSendToProjectIncharge = async () => {
    if (!selectedUserProjectIncharge || !selectedDocumentProjectIncharge) {
      alert('Please select user and upload document');
      return;
    }

    if (!projectId || !proposalId) {
      alert('Project ID and Proposal ID are required');
      return;
    }

    setSendingToProjectIncharge(true);

    try {
      const formData = new FormData();
      formData.append('project_id', projectId);
      formData.append('proposal_id', proposalId);
      formData.append('remarks', remarksProjectIncharge);
      formData.append('usr_id', selectedUserProjectIncharge);
      formData.append('document', selectedDocumentProjectIncharge);

      const response = await apiService.postTrackingSendToProjectInchargeLand(formData);

      if (response.status === 200) {
        alert('Successfully sent to Project Incharge');
        setShowSendToProjectInchargeModal(false);
        setSelectedUserProjectIncharge('');
        setRemarksProjectIncharge('');
        setSelectedDocumentProjectIncharge(null);
        fetchButtonStatus();
      } else {
        alert('Failed to send to Project Incharge');
      }
    } catch (error) {
      console.error(error);
    } finally {
      setSendingToProjectIncharge(false);
    }
  };

  const handleSendToTehsildar = async () => {
    if (!selectedUserTehsildar || !selectedDocumentTehsildar) {
      alert('Please select user and upload document');
      return;
    }

    if (!projectId || !proposalId) {
      alert('Project ID and Proposal ID are required');
      return;
    }

    setSendingToTehsildar(true);

    try {
      const formData = new FormData();
      formData.append('project_id', projectId);
      formData.append('proposal_id', proposalId);
      formData.append('remarks', remarksTehsildar);
      formData.append('usr_id', selectedUserTehsildar);
      formData.append('document', selectedDocumentTehsildar);

      const response = await apiService.postTrackingSendToTehsildarLand(formData);

      if (response.status === 200) {
        alert('Successfully sent to Tehsildar');
        setShowSendToTehsildarModal(false);
        setSelectedUserTehsildar('');
        setRemarksTehsildar('');
        setSelectedDocumentTehsildar(null);
        fetchButtonStatus();
      } else {
        alert('Failed to send to Tehsildar');
      }
    } catch (error) {
      console.error(error);
    } finally {
      setSendingToTehsildar(false);
    }
  };

  const fetchEditData = async () => {
    try {
      const data = await apiService.getLandPlotObjectionPublication(
        projectId,
        proposalId
      );

      if (data) {
        // 🔹 PAGE DISPLAY DATA
        setFormData({
          notification_no: data.notification_no || "",
          date: data.date || "",
          subject: data.subject || "",
          reference: data.reference || "",
          default_content: data.default_content || DEFAULT_MAIN_CONTENT,
          copy_forwarded_to: data.copy_forwarded_to || "",
          email: data.email || ""
        });

        // 🔹 EDIT MODAL DATA
        setEditForm({
          case_no: data.notification_no || "",
          date: data.date || "",
          objection_place: data.subject || "",
          main_content: data.default_content || DEFAULT_MAIN_CONTENT,
          email: data.email || ""
        });
      }
    } catch (error) {
      console.error("GET LandPlotObjectionPublication error:", error);
    }
  };


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleUpdate = async () => {
    const payload = {
      project_id: projectId,
      proposal_id: proposalId,
      notification_no: editForm.case_no,
      date: editForm.date,
      subject: editForm.objection_place,
      default_content: editForm.main_content,
      email: editForm.email
    };

    try {
      const res = await apiService.postAddUpdateLandPlotObjectionPublication(payload);

      // ✅ Check res.status instead of res?.status
      if (res?.status === 200) {
        alert(res?.message || "Update Successful");
        setShowEditModal(false);
        await fetchEditData();
      } else {
        alert(res?.message || "Update Failed");
      }
    } catch (error) {
      console.error("Update error:", error);
      alert("Update Failed: " + (error.message || "Unknown error"));
    }
  };

  const handlePrint = () => {
    const content = printRef.current.innerHTML;
    const win = window.open("", "", "width=900,height=700");
    win.document.write(`
    <html>
      <head>
        <title>Akshep Nirakaran Prasidhi Aheval</title>
        <style>
          body {
            font-family: "Noto Serif Devanagari", serif;
            padding: 40px;
            color: #000;
            font-size: 14px;
          }
          
          /* Border styles for the header box */
          .border {
            border-width: 1px;
          }
          
          .border-black {
            border-color: #000;
          }
          
          .border-b {
            border-bottom-width: 1px;
          }
          
          /* Flexbox layout */
          .flex {
            display: flex;
          }
          
          .justify-between {
            justify-content: space-between;
          }
          
          /* Padding */
          .px-3 {
            padding-left: 0.75rem;
            padding-right: 0.75rem;
          }
          
          .py-1 {
            padding-top: 0.25rem;
            padding-bottom: 0.25rem;
          }
          
          .p-10 {
            padding: 2.5rem;
          }
          
          /* Margins */
          .mt-2 {
            margin-top: 0.5rem;
          }
          
          .mt-3 {
            margin-top: 0.75rem;
          }
          
          .mt-4 {
            margin-top: 1rem;
          }
          
          .mt-6 {
            margin-top: 1.5rem;
          }
          
          .mt-8 {
            margin-top: 2rem;
          }
          
          .mt-10 {
            margin-top: 2.5rem;
          }
          
          .mb-2 {
            margin-bottom: 0.5rem;
          }
          
          .my-4 {
            margin-top: 1rem;
            margin-bottom: 1rem;
          }
          
          .ml-6 {
            margin-left: 1.5rem;
          }
          
          /* Text styles */
          .text-center {
            text-align: center;
          }
          
          .text-right {
            text-align: right;
          }
          
          .text-justify {
            text-align: justify;
          }
          
          .text-sm {
            font-size: 0.875rem;
          }
          
          .font-bold {
            font-weight: bold;
          }
          
          .leading-7 {
            line-height: 1.75rem;
          }
          
          /* Background */
          .bg-white {
            background-color: white;
          }
          
          .shadow {
            box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
          }
          
          .max-w-4xl {
            max-width: 56rem;
          }
          
          .mx-auto {
            margin-left: auto;
            margin-right: auto;
          }

          /* Page break control */
          @media print {
            .no-break {
              page-break-inside: avoid;
            }
          }
        </style>
      </head>
      <body>${content}</body>
    </html>
  `);
    win.document.close();
    win.focus();
    win.print();
    win.close();
  };

  return (
    <div className="p-6 bg-gray-100">
      <div className="flex justify-between items-center mb-4">
        <div className="flex gap-2">
          {/* <button className="relative">
            <label className="flex items-center space-x-2 px-4 py-2 bg-yellow-600 text-white rounded-md hover:bg-yellow-700 cursor-pointer">
              <Upload size={18} />
              <span>Upload Signature</span>
              <input
                type="file"
                accept="application/pdf,image/*"
                className="hidden"
                onChange={handleUploadedFile}
              />
            </label>
          </button>

          <button
            onClick={handleViewSignedPdf}
            className="flex items-center space-x-2 px-4 py-2 bg-purple-600 text-white rounded-md hover:bg-purple-700"
          >
            <Printer size={18} />
            <span>View Signed PDF</span>
          </button> */}

          <button
            onClick={() => setShowEditModal(true)}
            className="px-4 py-2 bg-blue-600 text-white rounded"
          >
            {translations[language].edit}
          </button>

          <button
            onClick={handlePrint}
            className="flex items-center gap-2 px-4 py-2 bg-green-600 text-white rounded"
          >
            {translations[language].Print}
          </button>

        </div>

          <div className="flex flex-wrap items-center gap-3 p-3 lg:ml-auto border border-purple-200 bg-purple-50 rounded-2xl shadow-sm min-w-max">
          <button
            onClick={() => setShowSendToTehsildarModal(true)}
            className="flex items-center gap-2 px-4 py-2 bg-green-600 text-white rounded"
          >
            {translations[language].Tehsilar}
          </button>

          <button
            onClick={() => setShowSendToProjectInchargeModal(true)}
            className="flex items-center gap-2 px-4 py-2 bg-green-600 text-white rounded"
          >
            {translations[language].SendToProjectIncharge}
          </button>
        </div>
      </div>


      {/* LETTER CONTENT */}
      <div
        ref={printRef}
        className="bg-white p-10 max-w-4xl mx-auto shadow"
      >
        {/* HEADER */}
        <div className="text-center font-bold leading-7">
          महाराष्ट्र शासन <br />
          जिल्हा पुनर्वसन विभाग <br />
          जिल्हाधिकारी कार्यालय, बुलढाणा
        </div>

        {/* HEADER BOX */}
        <div className="border border-black mt-4 text-sm">
          <div className="flex justify-between px-3 py-1 border-b border-black">
            <div>website : www.buldhana.nic.in</div>
            <div>e-mail : {formData.email}</div>
          </div>
          <div className="flex justify-between px-3 py-1">
            <div>जावक क्र. : {formData.notification_no}</div>
            <div>दिनांक : {formData.date ? new Date(formData.date).toLocaleDateString('hi-IN') : '१०/०६/२०'}</div>
          </div>
        </div>

        {/* TO */}
        <div className="mt-6">
          <p>प्रति</p>
          <p>१) तहसीलदार</p>
          <p className="ml-6">शेगाव</p>
          <p className="mt-2">२) सचिव</p>
          <p className="ml-6">
            ग्रामपंचायत कार्यालय, कोठरा ता. शेगाव जि. बुलढाणा
          </p>
        </div>

        {/* SUBJECT */}
        <div className="mt-4">
          <b>विषय :-</b>{" "}
          {formData.subject}
        </div>

        {/* BODY */}
        <p className="mt-2 text-justify leading-7">
          जिगाव प्रकल्पामुळे बाधित मौजे कोठरा तालुका शेगाव जिल्हा
          बुलढाणा येथील प्रकल्पग्रस्तांचे प्राप्त आक्षेपांतील
          निराकरण अहवाल प्रसिद्ध करणेबाबत.
        </p>

        {/* REFERENCE */}
        <div className="mt-4">
          <b>संदर्भ :-</b>{" "}
          {formData.reference || 'या कार्यालयाचे पत्र जा.क्र. पुनर्वसन-२९/काबी/तलाठी/३१८/२०२५ दिनांक १८.०५.२०२५'}
          दिनांक १८.०५.२०२५
        </div>

        <div className="text-center my-4">***</div>

        <p className="text-justify leading-7">
          {formData.default_content}
        </p>

        <p className="mt-3">
          <b>संलग्न :</b> आक्षेप निराकरण अहवाल (पाने १ ते २५)
        </p>

        {/* SIGNATURE */}
        <div className="mt-10 text-right">
          <div className="mt-10 text-right signature">
            <div className="font-bold">{fullName}</div>
            <div>{designation}</div>
          </div>
          <p>बुलढाणा</p>
        </div>

        {/* COPY */}
        <div className="mt-8">
          <b>प्रतिलिपी :-</b>
          <p className="mt-2">
            {'कार्यकारी अभियंता, जिगाव प्रकल्प धरण व पुनर्वसन विभाग, शेगाव यांना समादराने माहितीसाठी अवगत.'}
          </p>
        </div>

        <div className="mt-10 text-right">
          जिल्हा पुनर्वसन अधिकारी, <br />
          बुलढाणा
        </div>
      </div>

      {showEditModal && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
          <div className="bg-white rounded-xl w-full max-w-3xl p-6 relative">

            {/* Header */}
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-lg font-bold">संपादन करा</h2>
              <button onClick={() => setShowEditModal(false)}>✕</button>
            </div>

            {/* Proposal Details */}
            <div className="text-center mb-4">
              <span className="bg-blue-600 text-white px-4 py-1 rounded-full">
                Proposal Details
              </span>
            </div>

            <div className="grid grid-cols-3 gap-4">
              <div className="group">

                {/* जावक क्र. */}
                <label className="block font-semibold text-gray-700 mb-2 text-base">
                  जावक क्र. :
                </label>
                <input
                  value={editForm.case_no}
                  onChange={(e) => setEditForm({ ...editForm, case_no: e.target.value })}
                  placeholder="जावक क्र."
                  className="border p-2 rounded"
                />
              </div>
              <div className="group">
                {/* date */}
                <label className="block font-semibold text-gray-700 mb-2 text-base">
                  date :
                </label>
                <input
                  type="date"
                  value={editForm.date}
                  onChange={(e) => setEditForm({ ...editForm, date: e.target.value })}
                  className="border p-2 rounded"
                />
              </div>

              <div className="group">
                {/* email */}
                <label className="block font-semibold text-gray-700 mb-2 text-base">
                  email :
                </label>
                <input
                  value={editForm.email}
                  onChange={(e) => setEditForm({ ...editForm, email: e.target.value })}
                  placeholder="email"
                  className="border p-2 rounded"
                />
              </div>
            </div>

            <div className="grid grid-cols-2 gap-4 mt-4">
              <div className="group">

                {/* विषय  */}
                <label className="block font-semibold text-gray-700 mb-2 text-base">
                  विषय :
                </label>
                <input
                  value={editForm.objection_place}
                  onChange={(e) => setEditForm({ ...editForm, objection_place: e.target.value })}
                  placeholder="विषय"
                  className="border p-2 rounded"
                />
              </div>
            </div>

            {/* Main Content */}
            <div className="text-center mt-6 mb-2">
              <span className="bg-blue-600 text-white px-4 py-1 rounded-full">
                Main Content
              </span>
            </div>

            <textarea
              rows={8}
              value={editForm.main_content}
              onChange={(e) => setEditForm({ ...editForm, main_content: e.target.value })}
              className="w-full border rounded p-3 text-sm"
            />

            {/* Footer Buttons */}
            <div className="flex justify-end gap-3 mt-6">
              <button
                onClick={() => setShowEditModal(false)}
                className="px-4 py-2 border rounded"
              >
                रद्द करा
              </button>

              <button
                onClick={handleUpdate}
                className="px-4 py-2 bg-blue-600 text-white rounded"
              >
                बदल जतन करा
              </button>
            </div>

          </div>
        </div>
      )}

      {/* Send to Project Incharge Model */}
      {showSendToProjectInchargeModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-xl shadow-2xl w-full max-w-md mx-4 max-h-[90vh] overflow-y-auto">
            <div className="p-6">
              <div className="space-y-4">
                {/* User Selection */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    {translations[language]?.SelectProjectIncharge || 'Select Project Incharge'} *
                  </label>
                  <select
                    value={selectedUserProjectIncharge}
                    onChange={(e) => setSelectedUserProjectIncharge(e.target.value)}
                    disabled={loadingUsersProjectIncharge}
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  >
                    <option value="">
                      {loadingUsersProjectIncharge ? (translations[language]?.LoadingUsers || 'Loading Users...') : (translations[language]?.SelectUser || 'Select User')}
                    </option>
                    {usersProjectIncharge.map((user) => (
                      <option key={user.id || user.usr_id} value={user.id || user.usr_id}>
                        {user.full_name || user.user_name} ({user.usr_role || user.user_role})
                      </option>
                    ))}
                  </select>
                </div>

                {/* Remarks */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    {translations[language]?.Remarks || 'Remarks'}
                  </label>
                  <textarea
                    value={remarksProjectIncharge}
                    onChange={(e) => setRemarksProjectIncharge(e.target.value)}
                    rows={3}
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    placeholder="Enter remarks..."
                  />
                </div>

                {/* Document Upload */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Upload Document *
                  </label>
                  <input
                    type="file"
                    onChange={(e) => setSelectedDocumentProjectIncharge(e.target.files[0])}
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                  />
                  {selectedDocumentProjectIncharge && (
                    <div className="mt-2 p-3 bg-green-50 rounded-lg border border-green-200">
                      <div className="flex items-center justify-between mb-2">
                        <p className="text-sm text-green-700 font-medium truncate max-w-[60%]">
                          Selected: {selectedDocumentProjectIncharge.name}
                        </p>
                        <span className="text-xs text-green-600 bg-green-100 px-2 py-1 rounded-full">
                          {(selectedDocumentProjectIncharge.size / 1024 / 1024).toFixed(2)} MB
                        </span>
                      </div>
                      <div className="flex gap-2">
                        {selectedDocumentProjectIncharge.type === 'application/pdf' && (
                          <>
                            <button
                              type="button"
                              onClick={() => {
                                if (selectedDocumentProjectIncharge?.type === 'application/pdf') {
                                  setPdfForSigning(selectedDocumentProjectIncharge);
                                  setShowSignaturePad(true);
                                }
                              }}
                              disabled={uploadStatus === 'uploading'}
                              className="px-3 py-1 text-xs bg-purple-600 text-white rounded hover:bg-purple-700 disabled:bg-gray-400 disabled:cursor-not-allowed flex items-center gap-1 transition-colors"
                            >
                              {uploadStatus === 'uploading' ? (
                                <>
                                  <div className="animate-spin rounded-full h-3 w-3 border-b-2 border-white"></div>
                                  Signing...
                                </>
                              ) : (
                                <>
                                  <svg className="h-3 w-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
                                  </svg>
                                  Sign Doc
                                </>
                              )}
                            </button>

                          </>
                        )}
                      </div>
                      {uploadStatus === 'success' && (
                        <div className="mt-2 p-2 bg-green-100 border border-green-300 rounded text-xs text-green-700">
                          ✅ Document signed successfully!
                        </div>
                      )}
                      {uploadStatus === 'error' && uploadError && (
                        <div className="mt-2 p-2 bg-red-100 border border-red-300 rounded text-xs text-red-700">
                          ❌ {uploadError}
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>

              {/* Modal Actions */}
              <div className="flex justify-end gap-3 mt-6 pt-4 border-t">
                <button
                  onClick={() => {
                    setShowSendToProjectInchargeModal(false);
                    setSelectedDocumentProjectIncharge(null);
                    resetSignatureState();
                  }}
                  className="px-4 py-2 text-gray-600 border border-gray-300 rounded-lg hover:bg-gray-50"
                  disabled={sendingToProjectIncharge}
                >
                  {translations[language]?.Cancel || 'Cancel'}
                </button>

                <button
                  onClick={handleSendToProjectIncharge}
                  disabled={sendingToProjectIncharge || !selectedUserProjectIncharge || !selectedDocumentProjectIncharge}
                  className="px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 disabled:bg-gray-400 disabled:cursor-not-allowed flex items-center"
                >
                  {sendingToProjectIncharge ? (
                    <>
                      <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                      {translations[language]?.Sending || 'Sending...'}
                    </>
                  ) : (
                    <>
                      <div className="mr-2 h-4 w-4" />
                      {translations[language]?.send || 'Send'}
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Send to Tehsildar Model */}
      {showSendToTehsildarModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-xl shadow-2xl w-full max-w-md mx-4 max-h-[90vh] overflow-y-auto">
            <div className="p-6">
              <div className="space-y-4">
                {/* User Selection */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    {translations[language]?.SelectTehsildar || 'Select Tehsildar'} *
                  </label>
                  <select
                    value={selectedUserTehsildar}
                    onChange={(e) => setSelectedUserTehsildar(e.target.value)}
                    disabled={loadingUsersTehsildar}
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  >
                    <option value="">
                      {loadingUsersTehsildar ? (translations[language]?.LoadingUsers || 'Loading Users...') : (translations[language]?.SelectUser || 'Select User')}
                    </option>
                    {usersTehsildar.map((user) => (
                      <option key={user.id || user.usr_id} value={user.id || user.usr_id}>
                        {user.full_name || user.user_name} ({user.usr_role || user.user_role})
                      </option>
                    ))}
                  </select>
                </div>

                {/* Remarks */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    {translations[language]?.Remarks || 'Remarks'}
                  </label>
                  <textarea
                    value={remarksTehsildar}
                    onChange={(e) => setRemarksTehsildar(e.target.value)}
                    rows={3}
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    placeholder="Enter remarks..."
                  />
                </div>

                {/* Document Upload */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Upload Document *
                  </label>
                  <input
                    type="file"
                    onChange={(e) => setSelectedDocumentTehsildar(e.target.files[0])}
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                  />
                  {selectedDocumentTehsildar && (
                    <div className="mt-2 p-3 bg-green-50 rounded-lg border border-green-200">
                      <div className="flex items-center justify-between mb-2">
                        <p className="text-sm text-green-700 font-medium truncate max-w-[60%]">
                          Selected: {selectedDocumentTehsildar.name}
                        </p>
                        <span className="text-xs text-green-600 bg-green-100 px-2 py-1 rounded-full">
                          {(selectedDocumentTehsildar.size / 1024 / 1024).toFixed(2)} MB
                        </span>
                      </div>
                      <div className="flex gap-2">
                        {selectedDocumentTehsildar.type === 'application/pdf' && (
                          <>
                            <button
                              type="button"
                              onClick={() => {
                                if (selectedDocumentTehsildar?.type === 'application/pdf') {
                                  setPdfForSigning(selectedDocumentTehsildar);
                                  setShowSignaturePad(true);
                                }
                              }}
                              disabled={uploadStatus === 'uploading'}
                              className="px-3 py-1 text-xs bg-purple-600 text-white rounded hover:bg-purple-700 disabled:bg-gray-400 disabled:cursor-not-allowed flex items-center gap-1 transition-colors"
                            >
                              {uploadStatus === 'uploading' ? (
                                <>
                                  <div className="animate-spin rounded-full h-3 w-3 border-b-2 border-white"></div>
                                  Signing...
                                </>
                              ) : (
                                <>
                                  <svg className="h-3 w-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
                                  </svg>
                                  Sign Doc
                                </>
                              )}
                            </button>

                          </>
                        )}
                      </div>
                      {uploadStatus === 'success' && (
                        <div className="mt-2 p-2 bg-green-100 border border-green-300 rounded text-xs text-green-700">
                          ✅ Document signed successfully!
                        </div>
                      )}
                      {uploadStatus === 'error' && uploadError && (
                        <div className="mt-2 p-2 bg-red-100 border border-red-300 rounded text-xs text-red-700">
                          ❌ {uploadError}
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>

              {/* Modal Actions */}
              <div className="flex justify-end gap-3 mt-6 pt-4 border-t">
                <button
                  onClick={() => {
                    setShowSendToTehsildarModal(false);
                    setSelectedDocumentTehsildar(null);
                    resetSignatureState();
                  }}
                  className="px-4 py-2 text-gray-600 border border-gray-300 rounded-lg hover:bg-gray-50"
                  disabled={sendingToTehsildar}
                >
                  {translations[language]?.Cancel || 'Cancel'}
                </button>

                <button
                  onClick={handleSendToTehsildar}
                  disabled={sendingToTehsildar || !selectedUserTehsildar || !selectedDocumentTehsildar}
                  className="px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 disabled:bg-gray-400 disabled:cursor-not-allowed flex items-center"
                >
                  {sendingToTehsildar ? (
                    <>
                      <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                      {translations[language]?.Sending || 'Sending...'}
                    </>
                  ) : (
                    <>
                      <div className="mr-2 h-4 w-4" />
                      {translations[language]?.send || 'Send'}
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {showSignaturePad && pdfForSigning && (
        <SignaturePad
          pdfFile={pdfForSigning}
          onSign={(signaturesArray) => {
            setShowSignaturePad(false);

            // ✅ ONLY sign here
            signDocument(pdfForSigning, signaturesArray);

            setPdfForSigning(null);
          }}
          onCancel={() => {
            setShowSignaturePad(false);
            setPdfForSigning(null);
          }}
        />
      )}

      {isViewerOpen && viewerFile && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60">
          <div className="bg-white rounded-lg w-[80%] max-w-6xl h-[80%] relative">

            <div className="flex justify-between items-center px-4 py-2 border-b">
              <h3 className="text-lg font-semibold">Signed Document</h3>
              <button
                onClick={() => setIsViewerOpen(false)}
                className="text-xl font-bold"
              >
                ✕
              </button>
            </div>

            <iframe
              src={viewerFile}
              title="Signed PDF Viewer"
              className="w-full h-full"
            />
          </div>
        </div>
      )}

      {(uploadStatus === "signing" || uploadStatus === "uploading") && (
        <SignatureLoader
          text={
            uploadStatus === "signing"
              ? "Applying digital signature…"
              : "Uploading signed document…"
          }
        />
      )}
    </div>
  );
};

export default AkshepNirakaranPrasidhiAheval;
